import { Link } from 'react-router-dom';
import { siteInfo } from '@/mocks/photography';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-white">
      <div className="w-full px-6 md:px-10 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <h4 className="text-lg font-heading mb-4">秀人写真</h4>
            <p className="text-sm text-white/60 leading-relaxed">
              {siteInfo.description.slice(0, 80)}...
            </p>
          </div>

          <div>
            <h4 className="text-sm font-medium mb-4 text-white/90">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/" className="text-sm text-white/60 hover:text-white/85 transition-colors">首页</Link>
              <Link to="/category" className="text-sm text-white/60 hover:text-white/85 transition-colors">作品分类</Link>
              <Link to="/articles" className="text-sm text-white/60 hover:text-white/85 transition-colors">摄影指南</Link>
              <Link to="/about" className="text-sm text-white/60 hover:text-white/85 transition-colors">关于我们</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium mb-4 text-white/90">拍摄服务</h4>
            <div className="flex flex-col gap-2.5">
              <Link to="/category?type=personal" className="text-sm text-white/60 hover:text-white/85 transition-colors">个人写真</Link>
              <Link to="/category?type=couple" className="text-sm text-white/60 hover:text-white/85 transition-colors">情侣写真</Link>
              <Link to="/category?type=artistic" className="text-sm text-white/60 hover:text-white/85 transition-colors">艺术写真</Link>
              <Link to="/category?type=family" className="text-sm text-white/60 hover:text-white/85 transition-colors">亲子写真</Link>
            </div>
          </div>

          <div>
            <h4 className="text-sm font-medium mb-4 text-white/90">联系方式</h4>
            <div className="flex flex-col gap-3 text-sm text-white/60">
              <div className="flex items-center gap-2">
                <i className="ri-phone-line"></i>
                <span>{siteInfo.phone}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-mail-line"></i>
                <span>{siteInfo.email}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-map-pin-line"></i>
                <span>{siteInfo.address}</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-time-line"></i>
                <span>{siteInfo.workingHours}</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-white/40">
            &copy; {new Date().getFullYear()} 秀人写真. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors" aria-label="微信">
              <i className="ri-wechat-line text-lg"></i>
            </a>
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors" aria-label="微博">
              <i className="ri-weibo-line text-lg"></i>
            </a>
            <a href="#" className="text-white/40 hover:text-white/60 transition-colors" aria-label="小红书">
              <i className="ri-red-packet-line text-lg"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}